import React, { useCallback } from 'react';
import { useRouter } from 'next/router';

import type { SearchFilterNanoID } from '../../../../../../searchFilters/searchFiltersTypes';

import { useTeamShowPage } from '../../../../../hooks/useTeamShowPage';
import { useThirdPersonView } from '../../../../../../../app/hooks/useThirdPersonView';
import { GlobalCompanyTabsMenuDropdown } from '../../../../../../globalCompanyTabs/components/menus/GlobalCompanyTabsMenuDropdown';
import { TeamNanoID } from '../../../../../teamsTypes';
import { TeamPath } from '../../../../../TeamPath';
import {
  GlobalCompanyTabCompanyType,
  GlobalCompanyTabNanoID
} from '../../../../../../globalCompanyTabs/globalCompanyTabsTypes';

interface GlobalCompanyTabsDropdownProps {
  teamNanoId: TeamNanoID;
  activeFilterNanoId?: SearchFilterNanoID;
  onDeleteActiveFilter?: () => void;
  withCreateButton: boolean;
  withUpdateButton: boolean;
  withDeleteButton: boolean;
}

function GlobalCompanyTabsDropdown({
  teamNanoId,
  activeFilterNanoId,
  onDeleteActiveFilter,
  withCreateButton,
  withUpdateButton,
  withDeleteButton
}: GlobalCompanyTabsDropdownProps) {
  const { team } = useTeamShowPage({ teamNanoId });
  const { isThirdPersonView } = useThirdPersonView();
  const router = useRouter();
  const currentTabNanoId = router.query.tabNanoId as GlobalCompanyTabNanoID;

  const handleDeleteActiveTab = useCallback(() => {
    if (currentTabNanoId) {
      router.push(
        isThirdPersonView
          ? TeamPath.companyProfile(teamNanoId)
          : TeamPath.currentCompanyProfile()
      );
    } else {
      onDeleteActiveFilter?.();
    }
  }, [
    currentTabNanoId,
    isThirdPersonView,
    router,
    teamNanoId,
    onDeleteActiveFilter
  ]);

  if (!team) {
    return null;
  }

  const activeTabNanoId = activeFilterNanoId || currentTabNanoId;

  const companyType = (
    team.teamType?.endsWith('s') ? team.teamType.slice(0, -1) : team.teamType
  ) as GlobalCompanyTabCompanyType;

  return (
    <GlobalCompanyTabsMenuDropdown
      activeTabNanoId={activeTabNanoId}
      companyType={companyType}
      companyNanoId={team.nanoId}
      onDeleteActiveTab={handleDeleteActiveTab}
      isMenuOpen
      withCreateButton={withCreateButton}
      withUpdateButton={withUpdateButton}
      withDeleteButton={withDeleteButton}
    />
  );
}

export default GlobalCompanyTabsDropdown;
